var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123,
    height: 124,
    viewBox: "0 0 123 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1466 -958) translate(1466.787 958.781)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.112,
    cy: 74.008,
    fill: "#333",
    rx: 6.027,
    ry: 19.198,
    transform: "rotate(-39.938 104.112 74.008)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.273,
    cy: 67.341,
    r: 38.396,
    fill: "#333",
    transform: "rotate(-71.565 63.273 67.341)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M67.86 97.475H79.525V118.374H67.86zM44.531 97.475H56.196V118.374H44.531z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.804,
    cy: 118.617,
    fill: "#333",
    rx: 9.72,
    ry: 3.645
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.475,
    cy: 118.131,
    fill: "#333",
    rx: 9.72,
    ry: 3.645
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M51.217 19.077C54.646 5.269 69.78-2.856 85.02.928c15.24 3.785 24.816 18.045 21.387 31.852-3.428 13.808-14.803 13.852-30.043 10.068-15.24-3.784-28.574-9.964-25.146-23.771z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.027,
    cy: 49.525,
    fill: "#333",
    rx: 6.027,
    ry: 19.198,
    transform: "rotate(-64.626 20.027 49.525)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.533,
    cy: 59.239,
    r: 12.801,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.272,
    cy: 54.651,
    r: 4.267,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.423,
    cy: 85.967,
    r: 5.349,
    fill: "#FFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuy);
export default __webpack_public_path__ + "static/media/guy.c01c62842c82beb14b455d669d8a5e68.svg";
export { ForwardRef as ReactComponent };